import { atom, useAtomValue } from 'jotai';
import { atomEffect } from 'jotai-effect';

export type Device = 'mobile' | 'desktop';

const getDevice = (): Device => (
  window.location.pathname.includes('mobile') ? 'mobile' : 'desktop'
);

const deviceValueAtom = atom<Device>(getDevice());

deviceValueAtom.debugPrivate = true;

const deviceEffect = atomEffect((get, set) => {

  const handler = () => {

    set(deviceValueAtom, getDevice());

  };

  window.addEventListener('resize', handler);
  window.addEventListener('orientationchange', handler);

  return () => {

    window.removeEventListener('resize', handler);
    window.removeEventListener('orientationchange', handler);

  };

});

deviceEffect.debugPrivate = true;

export const deviceAtom = atom((get) => {

  get(deviceEffect);

  const device = get(deviceValueAtom);

  return {
    device,
    mobile: device === 'mobile',
    desktop: device === 'desktop',
  };

});

deviceAtom.debugLabel = 'device';

export const rootDeviceEffect = atomEffect((get) => {

  const { device } = get(deviceAtom);

  document.body.setAttribute('data-device', device);

});

export const useDevice = () => useAtomValue(deviceAtom);
